module.exports = "<div class=\"footer\">\r\n  <p>&copy; Copyright 2017. PT Cyberindo Primatama. All Right Reserved</p>\r\n  <a (click)=\"openDialogPrivacy()\">Privacy Policy</a>\r\n  <a (click)=\"openDialogTerms()\">Terms of Use</a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/footer/footer.component.html
// module id = ../../../../../src/app/_shared/layout/footer/footer.component.html
// module chunks = main